export const ADD_MENU = "ADD_MENU";
export const ADD_LANGUAGE = "ADD_LANGUAGE";